import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Finalized_lego.png")